export default {
  setSnackError (context, error) {
    context.commit('setSnackError', error)
  },
  setSnack (context, snack) {
    context.commit('setSnack', snack)
  }
}
